// Usage sample: JOURNEY=JOURNEY_ITEM~JOURNEY_ITEM~JOURNEY_ITEM
export const JOURNEY_SEPARATOR = '~'; // Separates a journey to journey items
export const JOURNEY_ITEM_SEPARATOR = '-'; // Separates a journey item to type and id

// Query param keys
export const JOURNEY_FIELD = 'journey';
export const VIEW_MODE_FIELD = 'full-page';
export const SELECTED_TAB_FIELD = 'selected-tab';
